/*
================================================================================
FILE HEADER — packages/ir/src/ulid.ts
================================================================================

CHANGE LOG
----------
| #  | Date       | Who               | Why               | What Changed        |
|----|------------|-------------------|-------------------|---------------------|
| 1  | 2026-06-23 | Claude Sonnet 4.6 | Phase 0 bootstrap | Created ULID utils  |

FILES THAT IMPORT THIS FILE
-----------------------------
- packages/ir/src/index.ts

EXPORTS COVERED
---------------
- newId()  — generates a new ULID string
- isId()   — validates a ULID string

IMPORTANT POINTS
----------------
1. All entity IDs in the IR (meta.id, step.id, flow.id) are ULIDs.
   They are sortable by creation time and stable across renames.
================================================================================
*/

import { ulid } from 'ulid';

export function newId(): string {
  return ulid();
}

// ULID: 26 characters, Crockford base32 alphabet
const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/i;

export function isId(value: string): boolean {
  return ULID_RE.test(value);
}
